import React, { useCallback, useState } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import dynamic from 'next/dynamic';

import '@splidejs/react-splide/css/core';
import { Image } from 'components/Image';
import { IImageBadge } from 'components/ImagesGallery/ImagesGallery';

import styles from './ImagesSlider.module.scss';

interface IImagesSlider {
  images: Array<string>;
  badges?: Array<IImageBadge>;
}

export const ImagesSlider: React.VFC<IImagesSlider> = ({ images, badges = [] }) => {
  const [currentImage, setCurrentImage] = useState(1);
  const [isLightBoxOpen, setIsLightBoxOpen] = useState(false);

  const LightBox = dynamic(import('../LightBox'), {
    ssr: false,
    loading: () => null, // TODO add loader if jumpy loadtime
  });

  const handleOnClickImage = useCallback((index: number) => {
    setCurrentImage(index);
    setIsLightBoxOpen(true);
  }, []);

  return (
    <div className={styles['images-slider']}>
      {badges.length ? (
        <div className={`${styles['badges-wrapper']}`}>
          {badges.map((item) => (
            <React.Fragment key={item.id}>{item.badge}</React.Fragment>
          ))}
        </div>
      ) : null}
      <Splide
        options={{
          arrows: false,
          autoWidth: false,
          pagination: true,
          perPage: 1,
          gap: '0.5rem',
          padding: { right: '2rem', left: '0' },
          classes: {
            pagination: 'splide__pagination splide-images-slider__pagination',
          },
        }}
        aria-label="Articles"
        onActive={(slide) => setCurrentImage(slide.index + 1)}
      >
        {images.map((image, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <SplideSlide className={styles['image-wrapper']} key={image + index}>
            <button
              className={styles['image-button']}
              onClick={() => handleOnClickImage(index)}
              type="button"
            >
              <Image
                src={image}
                loading={index === 0 || index + 1 === currentImage + 1 ? 'eager' : 'lazy'}
              />
            </button>
          </SplideSlide>
        ))}
      </Splide>
      <div className={styles['index-wrapper']}>{`${currentImage}/${images.length}`}</div>
      <LightBox
        images={images}
        startIndex={currentImage}
        isOpen={isLightBoxOpen}
        handleCloseBtn={() => setIsLightBoxOpen(false)}
      />
    </div>
  );
};

export default ImagesSlider;
